import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./MeetingInformationItem.module.css";
import CalenderDateIcon from "../CalenderDateIcon";
import InPersonMeetingIcon from "../InPersonMeetingIcon";
import VirtualMeetingIcon from "../VirtualMeetingIcon";

/**
 * View component, displays meeting information for meeting information slider and the meeting information modal window
 * has an onClick prop when clicking the calendar or virtual meeting icon
 */
export function MeetingInformationItem({
  years,
  months,
  days,
  location,
  state,
  city,
  time,
  isInPerson,
  isVirtual,
  isTextLight,
  onClick,
}) {
  return (
    <div
      className={classNames(
        styles.grid,
        styles.container,
        isTextLight ? styles.lightColorText : ""
      )}
    >
      <div className={classNames(styles.calendar)} onClick={onClick}>
        <CalenderDateIcon years={years} months={months} days={days} />
      </div>

      <div className={classNames(styles.textSide)}>
        <div className={classNames(styles.location)}>
          {city || state ? `${city}, ${state}` : ""}
        </div>
        <div className={classNames(styles.building)}>{location}</div>
        <div className={classNames(styles.time)}>{time}</div>

        <div className={classNames(styles.grid2)}>
          {isInPerson ? (
            <div>
              <InPersonMeetingIcon />
            </div>
          ) : (
            ""
          )}
          {isVirtual ? (
            <div className={classNames(styles.virtualIcon)} onClick={onClick}>
              <VirtualMeetingIcon />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}

MeetingInformationItem.propTypes = {
  month: PropTypes.string,
  days: PropTypes.arrayOf(PropTypes.string),
  location: PropTypes.string,
  building: PropTypes.string,
  time: PropTypes.string,
  isInPerson: PropTypes.bool,
  isVirtual: PropTypes.bool,
  isTextLight: PropTypes.bool,
  onClick: PropTypes.func,
};
